import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MessageService } from 'primeng/api';


import { TableModule } from 'primeng/table';
import { Subscription, firstValueFrom } from 'rxjs';
import { MessageServiceEnum, StaffService } from 'src/app/api';
import { ParticipantService } from 'src/app/api/participant.service';
import { GetTextMessagesResponse, TextMessageService } from 'src/app/api/text-message.service';
import { MissionControlHostService } from 'src/app/mission-control-host.service';

import { UiModule } from 'src/app/ui/ui.module';
import { SendTextMessageComponent } from "../../participant-components/send-text-message/send-text-message.component";
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';



interface TableViewModel extends GetTextMessagesResponse {
  staffName: string
}

@Component({
    selector: 'app-marketing-text-message',
    imports: [SelectModule, FormsModule, TextareaModule, TableModule, DatePipe, UiModule, SendTextMessageComponent],
    templateUrl: './marketing-text-message.component.html',
    styleUrl: './marketing-text-message.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarketingTextMessageComponent {

  

  textMessages = signal<TableViewModel[]>([])

  dialogVisible = model<boolean>(false)
  subscriptions: Subscription[] = []

  

  constructor(
    private participantService: ParticipantService,
    private messageService: MessageService,
    private textMessageService: TextMessageService,
    private staffService: StaffService,
    private mcHost: MissionControlHostService

  ) {

  }

  ngOnInit() {

    this.loadTextMessages()

   

  }


  

  loadTextMessages() {
    this.textMessageService.getTextMessages({ messageService: MessageServiceEnum.Marketing }).subscribe(
      async (results) => {
        const resultsWithName = (await Promise.all(results.map(async (r) => {

          const staff = await firstValueFrom(this.staffService.getUserById(r.staffId));

          return {
            ...r,
            staffName: staff ? `${staff.first} ${staff.last}` : ""
          };
        })
        ))
        .sort((a,b) => b.sendDate.valueOf() - a.sendDate.valueOf())
       

        this.textMessages.set(resultsWithName)
      }
    )
  }

  showNewMessage() {
    this.dialogVisible.set(true)
  }

  messageSent() {
    this.dialogVisible.set(false)
    this.loadTextMessages()
  }

}
